import { Action } from 'redux';

import ActionPayloadNumber from '../interfaces/actions/ActionPayloadNumber';

import * as Const from '../constants';

export const fetchDatepickersInitAction = (): Action => {
  return {
    type: Const.FETCH_DATEPICKERS_INIT,
  };
};

export const fetchDatepickersStartAction = (payload: number): ActionPayloadNumber => {
  return {
    type: Const.FETCH_DATEPICKERS_START_DATE,
    payload,
  };
};

export const fetchDatepickersEndAction = (payload: number): ActionPayloadNumber => {
  return {
    type: Const.FETCH_DATEPICKERS_END_DATE,
    payload,
  };
};

export const fetchDatepickersHideAction = (): Action => {
  return {
    type: Const.FETCH_DATEPICKERS_HIDE,
  };
};

export const fetchDatepickersShowAction = (): Action => {
  return {
    type: Const.FETCH_DATEPICKERS_SHOW,
  };
};
